import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListProdPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {

    return (
        <li className="stack-sm">
            <div className="flex-between">
                <div className="stack-sm">
                    <p className="h5-style notranslate">
                        {
                            props.performance.productionDetailPageLink != null && props.performance.productionDetailPageLink.length > 0 ?
                                <a target="_blank" href={props.performance.productionDetailPageLink}>{props.performance.title}</a>
                                :
                                props.performance.title
                        }
                    </p>
                    <div className="stack-sm h6-style">
                        <p>{props.performance.performanceDateString}</p>
                        <p>{props.performance.performanceTimeString}</p>
                        {
                            props.facilityDescription ?
                                <>
                                    <div className={`block-${props.theme}`}>
                                        <p className="h6-style themed-location">
                                            <svg className="svg-icon svg-icon-text" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                            </svg>
                                            <span className="icon-location-title notranslate">{props.facilityDescription}</span>
                                        </p>
                                    </div>
                                </> : null
                        }
                    </div>
                </div>
               
            </div>




        </li>
    );
}

export default ListProdPerformanceView;